import React from 'react';

// One badge style for every status in the app.
const BADGE_COLORS: Record<string, string> = {
  // job / operation statuses
  pending: 'bg-gray-600/20 text-gray-400',
  running: 'bg-blue-600/20 text-blue-400',
  completed: 'bg-primary/20 text-primary',
  failed: 'bg-red-600/20 text-red-400',
  cancelled: 'bg-gray-600/20 text-gray-400',
  authorized: 'bg-blue-600/20 text-blue-400',
  success: 'bg-primary/20 text-primary',
  error: 'bg-red-600/20 text-red-400',
  expired: 'bg-gray-600/20 text-gray-400',
  metered: 'bg-primary/20 text-primary',
  unmetered: 'bg-gray-600/20 text-gray-400',
  duplicate: 'bg-blue-600/20 text-blue-400',
  active: 'bg-primary/20 text-primary',
  revoked: 'bg-red-600/20 text-red-400',
  temp: 'bg-gray-600/20 text-gray-400',
  persistent: 'bg-primary/20 text-primary',
};

// size 'sm' is for page headers next to a large title.
export function Badge({ value, size = 'xs' }: { value: string; size?: 'xs' | 'sm' }) {
  const color = BADGE_COLORS[value] || 'bg-gray-600/20 text-gray-400';
  const text = size === 'sm' ? 'text-sm' : 'text-xs';
  return <span className={`${color} ${text} px-2 py-1 rounded font-medium whitespace-nowrap`}>{value}</span>;
}
